<template>
  <div class="breadcrumb--wrapper">
    <div class="breadcrumb non-transform">
      <div class="breadcrumb--left-section">
        <div class="breadcrumb--steps"><a href="/">Home</a> 
          <a :href='breadcrumb.page' v-for="(breadcrumb, index) in breadcrumbs" :key="index"> > {{ breadcrumb.name }}</a>
        </div>
        <div v-if='searchedString' class="breadcrumb--results">Results for "<span class="breadcrumb--results-data">{{ searchedString }}</span>" <span style='display:none;'>in Sealing</span></div>
        <div v-else class="breadcrumb--results">Search for Products in Catalog</div>
      </div>
      <div v-if='false' class="breadcrumb--right-section">
        <q-btn class="btn-go-to-page" label="Go to O-Rings Page" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia"
import { useSearchStore } from "../stores/search-store"
import { useFilterStore } from "../stores/filter-store"

const searchStore = useSearchStore()
const filterStore = useFilterStore()

const { searchedString } = storeToRefs(searchStore)
const { breadcrumbs } = storeToRefs(filterStore)
</script>

<style lang="scss" scoped>
.breadcrumb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px;
  max-width: 90%;
  margin: 0 auto;
  padding-left: 0 !important;
  padding-right: 0 !important;
  z-index: unset !important;
  
  @media (max-width: $breakpoint-xs) {
    // padding-bottom: 15px;
    padding-top: 0px;
  }

  &--wrapper {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
  &--left-section {
    color: #0566b1;
    letter-spacing: 0.5px;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    a {
      color: #0566b1;
      text-decoration: none;
      letter-spacing: 0.5px;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
    }
  }
  &--right-section {
    @media (max-width: $breakpoint-xs) {
      display: none;
    }
  }
  &--results {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #444444;
    letter-spacing: 0.1px;
    &-data {
      color: #0566b1;
    }
  }
}
.btn-go-to-page {
  background: #0684c7 !important;
  border-radius: 8px !important;
  color: #fff !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  letter-spacing: 0.1px !important;
  text-transform: none !important;
}
.breadcrumb--results{
  margin-top: 5px;
}
</style>
